import ContactsPage from "../../pages/legacy/contacts/ContactsPage";

const route = {
  key: "contacts",
  path: "/legacy/contacts",
  component: ContactsPage,
  private: true,
  layout: "main",
  icon: "faAddressBook",
  group: "sales",
  order: 30,
  permission: "legacy.contacts.read"
};

export default route;